// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"c0037c75","488":"1263b1e2"}[chunkId] + ".chunk.js";
};